import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    listCourseQuizzes: (courseId) => getRequest(`/courses/${courseId}/quizzes`),
    getQuiz: (id) => getRequest(`/quizzes/${id}`),
    listQuizBatch: (id) => getRequest(`/quizzes/${id}/batch`),
    createQuiz: (courseId, body) => postRequest(`/courses/${courseId}/quizzes`, body),
    updateQuiz: (id, body) => patchRequest(`/quizzes/${id}`, body),
    deleteQuiz: (id) => deleteRequest(`/quizzes/${id}`),
};

export default services;
